<app-basic-page [pageTitle]="'Usage & Billing'">
  <div class="basic-block">
    <div class="horizontal seperate balance">
      <div class="vertical full-width">
        <div class="section-title">{{ product?.name }}</div>

        @if (isLoading) {
          <nz-skeleton [nzActive]="true"></nz-skeleton>
        } @else {
          @if (activeInvoiceList.length > 0) {
            <div class="horizontal">
              <div class="credits">{{ userList().length }} / {{ availableMemberCount }}</div>
              <div class="points-text bottom">Members</div>
            </div>

            <div class="horizontal">
              <div class="credits">{{ sessionList().length }} / {{ availableCallCount }}</div>
              <div class="points-text bottom">Calls</div>
            </div>

            <app-update-subscription-button></app-update-subscription-button>
          } @else {
            <div class="horizontal">
              <app-primary-button (click)="onSubscribeClick()" [text]="'Subscribe'"></app-primary-button>
            </div>
          }
        }
      </div>
    </div>
  </div>
  <div class="basic-block">
    <div class="horizontal seperate balance">
      <div class="vertical">
        <div class="section-title">Billing History</div>
      </div>
    </div>

    <nz-table #historyTable [nzData]="invoiceList()" [nzPaginationType]="'small'" [nzPageSize]="8">
      <thead>
        <tr>
          <th>Product</th>
          <th [nzAlign]="'center'">Quantity</th>
          <th [nzAlign]="'center'">Price</th>
          <th>Start Date</th>
          <th>End Date</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (data of historyTable.data; track data.id; let i = $index) {
          @for (line of data.lines.data; track $index) {
            <tr>
              <td>{{ getProduct(line?.plan?.product)?.name }}</td>
              <td [nzAlign]="'center'">
                {{ line?.quantity }}
              </td>
              <td [nzAlign]="'center'">{{ line.amount / 100 | currency }}</td>
              <td>{{ getTime(line?.period?.start) }}</td>
              <td>{{ getTime(line?.period?.end) }}</td>
              <td>
                <button nz-button nzType="default" nzSize="small" (click)="onDownloadInvoiceClick(data)">
                  <span nz-icon style="font-size: 16px" class="material-symbols-rounded">download</span>
                  Invoice
                </button>
              </td>
            </tr>
          }
        }
      </tbody>
    </nz-table>
  </div>

  <div class="basic-block">
    {{ 'For support, please contact hello@peakmojo.ai' }}
  </div>
</app-basic-page>
